import { LoadMask } from './LoadMask'

export const ListBlankLoadMask = () => {
  return (
    <section className="max-w-[1200px] mx-auto text-[#444]">
      <LoadMask active={true}></LoadMask>
    </section>
  )
}
